import { LANGUAGE_NAMES } from 'project.config';

type Props = {
  language: string;
};
const LanguageCurrent: React.FC<Props> = ({ language }) => {
  return (
    <div className="inline-flex items-center justify-center rounded-full bg-primary-green px-6 py-3 text-[18px]/[22.68px] font-semibold text-white">
      {LANGUAGE_NAMES[language]}
    </div>
  );
};
export default LanguageCurrent;
